import React from 'react'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Button } from '@mui/material'
import useModals from 'src/Hooks/useModals'
import { Badge, useGetBadges } from 'src/Libs/flow/end-user-settings/badges-for-charging-station'
import { useInstallationAccessRightsContext } from 'src/Libs/installation-rights-management/provider/InstallationAccessRightsContext'
import { AccordionItem } from '@e3dc-react/shell/Elements/Accordion'
import { Box } from '@mui/system'
import useAccordionStyle from 'src/Libs/styles'

/** A list of RFID cards with an button to add new ones */
export const RfidCardsSection: React.FC<{ installationId: number }> = ({ installationId }) => {
  const { classes } = useAccordionStyle()

  const { t } = useCustomTranslation()
  const { hasInstallationWritingRights: canEdit } = useInstallationAccessRightsContext()
  const { openEditBadgeDialog } = useModals()

  const { data: rfidCards } = useGetBadges(installationId)

  const handleEditClick = (): void => {
    openEditBadgeDialog({
      initialBadge: null,
      installationId,
    })
  }

  if (!rfidCards) return null

  return (
    <AccordionItem title={t('installation.rfidCardSection.title')} expanded accordionDetailsSx={{ px: 4, py: 0 }} className={classes.accordion}>
      {rfidCards
        .filter(rfidCard => rfidCard !== null)
        ?.map(badge => (
          <Badge key={badge.id ?? ''} installationId={installationId} badge={badge} />
        ))}
      <Box pb={4}>
        <Button variant="outlined" color="primary" onClick={handleEditClick} disabled={!canEdit}>
          {t('user-settings.badges-page.add-badge')}
        </Button>
      </Box>
    </AccordionItem>
  )
}
